import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AddersCategoriesService from "./AddersCategoriesService";

const initialState = {
    adders_categories: [],
    adders_category: [],
    category_childrens: [],
    services: [],
    isSuccess: false,
    isLoading: false,
    isError: false,
    errors: [],
    message: null,
};

export const GetAllAddersCategories = createAsyncThunk(
    "adder_categories/index",
    async (data, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersCategoriesService.GetAllAddersCategories(data, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);

export const GetAllCategoriesChildrens = createAsyncThunk(
    "adder_categories/get_group_childrens",
    async (data, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersCategoriesService.GetAllCategoriesChildrens(data, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);

export const GetSingleAdderGroupMethod = createAsyncThunk(
    "adder_categories/show",
    async (id, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersCategoriesService.GetSingleGroupList(id, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);

export const CreateAdderCategoriesMethod = createAsyncThunk(
    "adder_categories/create_group",
    async (data, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersCategoriesService.CreateAdderCategory(data, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);

export const CreateCategoryChildrenMethod = createAsyncThunk(
    "adder_categories/create_children",
    async (data, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersCategoriesService.CreateCategoryChildren(data, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);

export const UpdateAdderCategoryMethod = createAsyncThunk(
    "adder_categories/update",
    async (data, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersCategoriesService.UpdateAdderCategory(data, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);

export const DeleteAddreCategoryMethod = createAsyncThunk(
    "adder_categories/delete",
    async (id, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersCategoriesService.DeleteAddreGroupCategory(id, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);

export const DeleteAddreGroupMembersCategory = createAsyncThunk(
    "adder_categories/delete_children",
    async (id, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersCategoriesService.DeleteAddreGroupMembersCategory(id, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);

const AddersCategoriesSlice = createSlice({
    name: "adders_categories",
    initialState,
    reducers: {
        adderCategoriesReset: (state) => {
            state.isSuccess = false;
            state.isLoading = false;
            state.isError = false;
            state.errors = [];
            state.message = null;
        },
    },
    extraReducers: {
        // Get All Adders
        [GetAllAddersCategories.pending]: (state) => {
            state.isLoading = true;
        },
        [GetAllAddersCategories.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            state.adders_categories = action.payload;
        },
        [GetAllAddersCategories.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },

        [GetAllCategoriesChildrens.pending]: (state) => {
            state.isLoading = true;
        },
        [GetAllCategoriesChildrens.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            state.category_childrens = action.payload;
        },
        [GetAllCategoriesChildrens.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },

        // Get Single Adders
        [GetSingleAdderGroupMethod.pending]: (state) => {
            state.isLoading = true;
        },
        [GetSingleAdderGroupMethod.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            state.adders_category = action.payload;
        },
        [GetSingleAdderGroupMethod.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },

        // Create Adders
        [CreateAdderCategoriesMethod.pending]: (state) => {
            state.isLoading = true;
        },
        [CreateAdderCategoriesMethod.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            state.adders_category = action.payload;
        },
        [CreateAdderCategoriesMethod.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },

        [CreateCategoryChildrenMethod.pending]: (state) => {
            state.isLoading = true;
        },
        [CreateCategoryChildrenMethod.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            state.adders_category = action.payload;
        },
        [CreateCategoryChildrenMethod.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },

        // Update Adders
        [UpdateAdderCategoryMethod.pending]: (state) => {
            state.isLoading = true;
        },
        [UpdateAdderCategoryMethod.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.adders_category = action.payload;
        },
        [UpdateAdderCategoryMethod.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.payload;
        },

        // Delete Adders
        [DeleteAddreCategoryMethod.pending]: (state) => {
            state.isLoading = true;
        },
        [DeleteAddreCategoryMethod.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            state.adders_category = action.payload;
        },
        [DeleteAddreCategoryMethod.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },

        [DeleteAddreGroupMembersCategory.pending]: (state) => {
            state.isLoading = true;
        },
        [DeleteAddreGroupMembersCategory.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            state.adders_category = action.payload;
        },
        [DeleteAddreGroupMembersCategory.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },
        
    },
});

export const { adderCategoriesReset } = AddersCategoriesSlice.actions;
export default AddersCategoriesSlice.reducer;
